import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import { Setting as terms } from '@/const/terms/mainTerms';
import { ComponentTerms as compTerms } from '@/const/terms/componentTerms';
import { EditAudience as feedbackOfAudience } from '@/const/terms/feedback/audience';

import { PLATFORM_MAP } from '@/const/options';
import { IAudienceData } from '@/pages/audience/types';
import { AudienceResponse } from '@/pages/campaign/adset/editingTypes';
import { AudienceFilterType } from '@/pages/campaign/adset/editingTypes';

import { Table as ElTable } from 'element-ui';

import AudienceStatusColumn from '@/components/ElementComponent/Column/AudienceStatusColumn.vue';
import NumberColumn from "@/components/ElementComponent/Column/NumberColumn.vue";
import DateColumn from "@/components/ElementComponent/Column/DateColumn.vue";
import { AxiosError, AxiosResponse } from 'axios';
import { AUDIENCE_STATUS } from '@/const/status';


@Component<AudienceSelectDialog>({
    name: 'AudienceSelectDialog',
    components: {
        AudienceStatusColumn,
        NumberColumn,
        DateColumn,
    },
})
export default class AudienceSelectDialog extends Vue {
    @Prop({ type: Array, required: true }) private value!: IAudienceData[];
    @Prop({ type: Boolean, required: true }) private visible!: boolean;

    get model() { return this.value }
    set model(v: IAudienceData[]) { this.$emit('input', v) }

    private valueCopy: IAudienceData[] = [];

    @Watch('value', { deep: true })
    private updateKeepSelected(val: IAudienceData[]) {
        let oldVal = this.valueCopy;

        const newIDs = val.map((item: IAudienceData) => item.id);
        const oldIDs = oldVal.map((item: IAudienceData) => item.id);
        const addedAudience = val.filter((audience: IAudienceData) => {
            const isInNew = newIDs.includes(audience.id);
            const isInOld = oldIDs.includes(audience.id);
            return (isInNew && !isInOld);
        })
        const inListIDs = this.audienceList.map((item: IAudienceData) => item.id);
        const addedIDs = addedAudience.map((item: IAudienceData) => item.id);

        this.keepSelectedAudiences = [
            ...this.keepSelectedAudiences.filter((audience: IAudienceData) => {
                const isInNew = newIDs.includes(audience.id);
                const isInOld = oldIDs.includes(audience.id);
                return ((!inListIDs.includes(audience.id)) && !(!isInNew && isInOld));
            }),
            ...addedAudience,
        ]

        this.selectedAudiences = [
            ...this.selectedAudiences.filter((audience: IAudienceData) => {
                const isInNew = newIDs.includes(audience.id);
                const isInOld = oldIDs.includes(audience.id);
                return (!(!isInNew && isInOld));
            }),
            ...this.audienceList.filter((audience: IAudienceData) => addedIDs.includes(audience.id)),
        ];
        this.valueCopy = this.model.map((audience: IAudienceData) => audience);
    }
    get visibleSync() { return this.visible }
    set visibleSync(v: boolean) { this.$emit('update:visible', v) }
    @Watch('visible')
    private refreshAudienceList(val: boolean) {
        if (val) {
            this.$nextTick(() => {
                const keepedID = this.keepSelectedAudiences.map((v: IAudienceData) => v.id);
                this.keepSelectedAudiences = this.keepSelectedAudiences.concat(
                    ...this.selectedAudiences.filter((v: IAudienceData) => !keepedID.includes(v.id))
                );
                
                const table = this.$refs.audienceTable as ElTable;
                table.clearSelection();
                this.audienceList.forEach((row: IAudienceData) => {
                    const keeped = this.keepSelectedAudiences.find((v) => v.id === row.id);
                    if (keeped) {
                        table.toggleRowSelection(row, true);
                        this.keepSelectedAudiences.splice(this.keepSelectedAudiences.indexOf(keeped), 1);
                    }
                })
            })
        }
    }

    private terms = terms;
    private currentCompTerms = compTerms.form.adset.audience;
    private compTerms = compTerms;

    private PLATFORM_MAP = PLATFORM_MAP

    private blockSelection: boolean = false;
    private maxSelect: number = 10;

    private audienceList: IAudienceData[] = [];
    private filterForm: AudienceFilterType = { totalPages: 0, page: 1, query: '' };

    private loading: boolean = false;
    private selectedAudiences: IAudienceData[] = [];
    private keepSelectedAudiences: IAudienceData[] = [];

    private getAudienceResponseHandler() {
        const keepedID = this.keepSelectedAudiences.map((v: IAudienceData) => v.id);
        this.keepSelectedAudiences = this.keepSelectedAudiences.concat(
            ...this.selectedAudiences.filter((v: IAudienceData) => !keepedID.includes(v.id))
        );
        this.loading = true;
        this.getAudienceResponse().then((res: any) => res.data)
            .then((data: AudienceResponse) => {
                this.audienceList = data.audiences;
                this.filterForm.totalPages = data.pages;
                return data;
            })
            .then((data: AudienceResponse) => {
                if (this.keepSelectedAudiences.length) {
                    const table = this.$refs.audienceTable as ElTable;
                    data.audiences.forEach((row: IAudienceData) => {
                        const keeped = this.keepSelectedAudiences.find((v) => v.id === row.id);
                        if (keeped) {
                            table.toggleRowSelection(row, true);
                            this.keepSelectedAudiences.splice(this.keepSelectedAudiences.indexOf(keeped), 1);
                        }
                    })
                }
            })
            .catch((err: AxiosError) => {
                if ((err.response as AxiosResponse) && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackOfAudience.editing.error.getResponse);
                } else {
                    this.$notify.error(err.message);
                }
                throw err;
            })
            .finally(() => { this.loading = false })
    }
    private applySelectedAudiences() {
        this.visibleSync = false
        const targetFolders = [
            ...this.selectedAudiences,
            ...this.keepSelectedAudiences,
        ]
        this.model = targetFolders.map((item: IAudienceData) => item);
    }
    private audienceSelectHandler(val: IAudienceData[], row: IAudienceData) {
        if (this.selectedAudiences.length + this.keepSelectedAudiences.length > this.maxSelect) {
            const table = this.$refs.audienceTable as ElTable;
            this.blockSelection = true;
            if (row) {
                table.toggleRowSelection(row);
            } else {
                table.clearSelection();
            }
        } else {
            this.blockSelection = false;
        }
    }
    private audienceSelectChangedHandler(val: IAudienceData[]) {this.selectedAudiences = val}
    private makeAudienceHandler() {
        const routerData = this.$router.resolve({ name: 'audienceNew' });
        const child = window.open(routerData.href, '_blank') as Window;
        if (child.postMessage) {
            let message = 'audienceNewRequest';
            let callCnt = 10;
            let msgHandler = setInterval(() => {
                if (callCnt <= 0) {
                    clearInterval(msgHandler);
                    return;
                }
                child.postMessage(message, child.origin);
                callCnt--;
            }, 500);

            window.addEventListener('message', (e) => {
                if (e.origin === window.origin) {
                    if (e.data === message + 'true') {
                        if (msgHandler) clearInterval(msgHandler);
                        this.$notify.success(feedbackOfAudience.new.success);
                        this.getAudienceResponseHandler();
                        return;
                    }
                    if (e.data === message + 'false') {
                        if (msgHandler) clearInterval(msgHandler);
                        // statement
                        return;
                    }
                    if (e.data === message + 'ready') {
                        callCnt = 10;
                        msgHandler = setInterval(() => {
                            if (callCnt <= 0) {
                                clearInterval(msgHandler);
                                return;
                            }
                            child.postMessage(message, child.origin);
                            callCnt--;
                        }, 500);
                        return;
                    }
                    if (e.data === message + 'connected') {
                        if (msgHandler)
                            clearInterval(msgHandler);
                        return;
                    }
                }
            })
        } else {
            child.onclose = () => {
                this.getAudienceResponseHandler();
            }
        }
    }
    
    private getAudienceResponse() {
        return this.$http.adserverAPI.post('GetAudienceSummary', {
            status: AUDIENCE_STATUS.DONE,
            page_no: this.filterForm.page,
            query: this.filterForm.query,
        });
    }
    
    private created() {
        this.$nextTick(() => {
            this.getAudienceResponseHandler();
        });
    }
}